import { useStore } from 'zustand';

import { likeStatusStore } from '../store/LikeStore';

export function useLikeStatusSelector(id: string): boolean {
  const isLike = useStore(likeStatusStore, (state) => state[id]);
  return isLike ?? false;
}
